import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface TagsKeyType {
  add: LocalesKey;
  plural: LocalesKey;
  singular: LocalesKey;
  select: LocalesKey;
  change: LocalesKey;
  createTag: LocalesKey;
  createTeamCustomTag: LocalesKey;
  customTags: LocalesKey;
  deleteTag: LocalesKey;
  deleteWarning: LocalesKey;
  removeAllOtherTags: LocalesKey;
  tagType: LocalesKey;
}

export const tagsKeys = keyPathMirror<TagsKeyType, string>(
  {
    add: null,
    plural: null,
    singular: null,
    select: null,
    change: null,
    createTag: null,
    createTeamCustomTag: null,
    customTags: null,
    deleteTag: null,
    deleteWarning: null,
    removeAllOtherTags: null,
    tagType: null
  },
  'models.tags.'
);
